import React from 'react';
import { colors } from '../tokens';
import { useTheme } from '../theme';

export type SpinnerSize = 'sm' | 'md' | 'lg';
export type SpinnerVariant = 'primary' | 'white' | 'dark';

export interface SpinnerProps {
  size?: SpinnerSize;
  label?: string;
  variant?: SpinnerVariant;
  'aria-hidden'?: boolean;
}

const sizePx: Record<SpinnerSize, number> = { sm: 16, md: 24, lg: 40 };
const borderWidth: Record<SpinnerSize, string> = { sm: '2px', md: '3px', lg: '4px' };

function getColor(variant: SpinnerVariant, dark: boolean): string {
  if (variant === 'white') return colors.neutral.white;
  if (variant === 'dark') return colors.neutral.black;
  return dark ? colors.primary.yellow : colors.neutral.black;
}

export function Spinner({ size = 'md', label = 'Sedang memuatkan...', variant = 'primary', 'aria-hidden': ariaHidden }: SpinnerProps) {
  const { dark } = useTheme();
  const px = sizePx[size]!;
  const bw = borderWidth[size]!;
  const ringColor = getColor(variant, dark);

  return (
    <span
      role={ariaHidden ? undefined : 'status'}
      aria-label={ariaHidden ? undefined : label}
      aria-hidden={ariaHidden}
      style={{
        display: 'inline-block',
        width: px,
        height: px,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          display: 'block',
          width: px,
          height: px,
          borderRadius: '50%',
          border: `${bw} solid transparent`,
          borderTopColor: ringColor,
          borderRightColor: ringColor,
          animation: 'skit-spin 0.65s linear infinite',
        }}
      />
      {!ariaHidden && label && (
        <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)' }}>
          {label}
        </span>
      )}
    </span>
  );
}
